<template>
  <div class="earth-options-data-dialog">
    <el-collapse v-model="activeNames">
      <el-collapse-item title="数据源" name="1">
        <div class="data-source-type">
          <!-- <div class="dataSource-item" @click="goToChooseData">
            <span>进入数据管理后台 </span>
          </div> -->
          <data-center-choose 
            :checkStatus="checkStatus"
            :myId="ids"
            :options="options"
            :type="chart_screen"
            @onDataCenterChange="onDataCenterChange"
            @onAfterDataCenterChoose="onAfterDataCenterChoose"
          />
        </div>
      </el-collapse-item>
      <el-collapse-item title="更多" name="2">
        <div class="data-source-type">
          <auto-update-timer :isLocal="false" type="chart_screen"/>
          <div class="mt12">
            <!-- <div class="getDataBtn mb12" @click="getBaseModuleDataLoop">查看数据响应结果</div> -->
            <cx-check-box v-if="request_prefix==='bigScreen'" :value.sync="usePageQuery">开启跨页面传参</cx-check-box>
          </div>
        </div>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
import autoUpdateTimer from "components/toolbar-option-components/utilsComponents/autoUpdateTimer/autoUpdateTimer.vue"
import dataCenterChoose from "publicSetting/dataCenterChoose.vue"
export default {
  components: {
    autoUpdateTimer,
    dataCenterChoose
  },
  data() {
    return {
      activeNames: ["1"],
      this1: this,
      fetchEnd: false
    }
  },
  props: { options: Object },
  mounted() {
    this.$eventBus.$on("update-toolbar-data", this.updateToolbarData)
  },
  beforeDestroy() {
    this.$eventBus.$off("update-toolbar-data", this.updateToolbarData)
  },
  methods: {
    collapseMouseDown($event, val) {
      if ($event.target.classList[0] === "el-collapse-item__header") {
        const _index = this.collapseActiveNames.findIndex(it => it === val)
        _index === -1 ? this.collapseActiveNames.push(val) : ""
      }
    },
    goToChooseData() {
      if (this.fetchEnd) return
      this.fetchEnd = true
      const { websiteId, pageId, sign, wfwfid } = this.$store.state.states.getDataPageIds
      const rectAttr = this.getAttrById.call(this, this.$store.state[this.request_prefix], this.ids)
      let { moduleId, appId } = rectAttr
      if (moduleId === undefined) moduleId = rectAttr?.options?.moduleId
      if (appId === undefined) appId = rectAttr?.options?.appId
      if (!moduleId || !appId) {
        this.$saveModule(this.ids, "31CB73E03E24BBFF", "临时", true)
          .then(res => {
            this.fetchEnd = false
            if (res.appId) {
              // 模板问题，第一次需要手动将数据源切换为本地数据
              this.$API.setLocalData({ appId: res.appId, type: "chart_screen" }).then(() => {
                window.open(`/engine2/data/api-v2/admin/chart_screen/${res.appId}?w=${websiteId}&p=${pageId}&hideDataContent=true`)
                this.restDataUrl = `engine2/data/api-v2/chart/${res.appId}/data`
              })
            }
          })
          .catch(err => (this.fetchEnd = false))
      }
      this.fetchEnd = false
      if (appId) window.open(`/engine2/data/api-v2/admin/chart_screen/${appId}?w=${websiteId}&p=${pageId}&hideDataContent=true`)
      this.restDataUrl = `engine2/data/api-v2/chart/${appId}/data`
    },
    async getBaseModuleDataLoop() {
      if (this.restDataUrl !== "") {
        this.$changeOptionsEV(
          this.restDataUrl.length === this.restDataUrl.trim().length ? this.restDataUrl + " " : this.restDataUrl.trim(),
          "restDataUrl",
          false
        )
      }
    },
    async getGeneralRest(appId, wfwfid, websiteId, pageId) {
      return this.$API.queryAppCategoryAndApp({
        appId: appId,
        wfwfid: wfwfid,
        websiteId: websiteId,
        pageId: pageId
      })
    },
    onDataCenterChange() {
      this.getBaseModuleDataLoop()
    },
    onAfterDataCenterChoose(appId) {
      this.restDataUrl = `engine2/data/api-v2/chart/${appId}/data`
    },
    updateToolbarData() {
      this.getBaseModuleDataLoop()
    }
  },
  computed: {
    ids() {
      return this.$store.state.states.activeID
    },
    restDataUrl: {
      get() {
        return this.options && this.options.restDataUrl !== "" ? this.options.restDataUrl : ""
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "restDataUrl", false)
      }
    },
    usePageQuery: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "usePageQuery", "usePageQuery", false)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "usePageQuery", false)
      }
    },
    checkStatus() {
      return this.getRectAttribute.call(this, this.ids).appId
    }
  }
}
</script>

<style lang="scss" scoped>
.dataSource-item {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 32px;
  background: var(--leftMenuBgColor);
  border: 1px solid var(--themeColor);
  border-radius: 4px;
  font-size: 14px;
  color: var(--themeColor);
  &:hover {
    cursor: pointer;
  }
}
.getDataBtn {
  background: var(--themeColor);
  border-radius: 4px;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  color: #ffffff;
  padding: 6px 0px;
}
.getDataBtn:hover {
  cursor: pointer;
}
</style>
